import React from 'react';

interface ArchiveIconProps {
  className?: string;
  color?: string;
  size?: number;
}

export const ArchiveIcon: React.FC<ArchiveIconProps> = (props) => {
  const { className, color = '#23375E', size = 36 } = props;
  return (
    <svg
      width={size}
      height={size}
      className={className}
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3 7.5C3 5.84315 4.34315 4.5 6 4.5H30C31.6569 4.5 33 5.84315 33 7.5V10.5C33 11.6206 32.3856 12.5977 31.4752 13.1128C31.4916 13.2396 31.5 13.3688 31.5 13.5V28.5C31.5 30.1569 30.1569 31.5 28.5 31.5H7.5C5.84315 31.5 4.5 30.1569 4.5 28.5V13.5C4.5 13.3688 4.50842 13.2396 4.52475 13.1128C3.61442 12.5977 3 11.6206 3 10.5V7.5ZM30 10.5V7.5H6V10.5H30ZM7.5 13.5V28.5H28.5V13.5H7.5ZM12 18C12 17.1716 12.6716 16.5 13.5 16.5H22.5C23.3284 16.5 24 17.1716 24 18C24 18.8284 23.3284 19.5 22.5 19.5H13.5C12.6716 19.5 12 18.8284 12 18Z"
        fill={color}
      />
    </svg>
  );
};
